import React from "react";
import { Box, Typography, Link } from "@mui/material";
import { useArgusAuth } from "../../hooks/useArgusAuth";
import { useMediaQuery } from "react-responsive";
import { COLORS } from "../../constants";
import DesktopSiteBottombar from "./DesktopSiteBottombar";
import MobileSiteBottombar from "../MobileHeader/MobileSiteBottombar";
import useSystemHook from "./../../hooks/SystemHook";

const SiteBottombar = ({ categoriesAndTypes, toggleCategories }) => {
  const { user, isLoading, isAuthenticated } = useArgusAuth();

  const { isMobile, isTablet, isDesktop } = useSystemHook();

  if (isLoading) return null;

  return (
    <>
      {isMobile === true && (
        <MobileSiteBottombar
          user={user}
          isAuthenticated={isAuthenticated}
          isLoading={isLoading}
          toggleCategories={toggleCategories}
        />
      )}
      {isMobile === false && (
        <DesktopSiteBottombar
          categoriesAndTypes={categoriesAndTypes}
          user={user}
          isAuthenticated={isAuthenticated}
          isLoading={isLoading}
        />
      )}
    </>
  );
};

export default SiteBottombar;
